import type { ContextState } from '../../types';
import type { ActionType } from './types';

export function reducer(prevState: ContextState, action: ActionType): ContextState {
  const { currentStep } = prevState;
  switch (action.type) {
    case 'setTermsAndConditions': {
      const { termsAndConditionsAccepted } = action;

      return {
        ...prevState,
        termsAndConditionsAccepted,
      };
    }
    case 'stepBack': {
      return {
        ...prevState,
        currentStep: currentStep - 1,
      };
    }
    case 'goToSummary': {
      return {
        ...prevState,
        currentStep: currentStep + 1,
      };
    }
    case 'setCurrentStep': {
      return {
        ...prevState,
        currentStep: action.step,
      };
    }

    case 'setFrequency': {
      return {
        ...prevState,
        selectedFrequency: action.item,
      };
    }

    case 'setExistingCustomer': {
      return {
        ...prevState,
        newCustomer: undefined,
        existingCustomer: action.existingCustomer,
      };
    }
    case 'setPackage': {
      return {
        ...prevState,
        selectedPackage: action.packageItem,
        currentStep: currentStep + 1,
      };
    }
    case 'setCustomerType': {
      return {
        ...prevState,
        selectedCustomerType: action.customerType,
        existingCustomer: null,
        newCustomer: undefined,
      };
    }
    case 'setCustomerName': {
      const { newCustomer } = prevState;

      return {
        ...prevState,
        existingCustomer: null,
        newCustomer: {
          ...newCustomer,
          firstName: action.firstName,
        },
      };
    }
    case 'setCustomerSurname': {
      const { newCustomer } = prevState;

      return {
        ...prevState,
        existingCustomer: null,
        newCustomer: {
          ...newCustomer,
          surname: action.surname,
        },
      };
    }
    default:
      return prevState;
  }
}
